const state = {
  accounts: [],
  profile: {},
  userRevs: [],
  accountsForRevCreate: [],
}

export default state
